interface IProps {
    handleChangeClick: () => void,
    isOn: boolean,
    label: string
}

const PopupItemToggle = ({ label, isOn, handleChangeClick }: IProps) => {

    return (
        <li className={"space-x-6 justify-between min-w-80 flex items-center px-4 py-2"}>
            <p>{label}</p>
            <button
                type="button"
                className="justify-self-end group relative inline-flex h-5 w-10 cursor-pointer items-center justify-center rounded-full focus:outline-hidden focus:ring-2 focus:ring-[#008DD2] focus:ring-offset-2 ring-offset-white"
                role="switch"
                aria-checked="false"
                onClick={handleChangeClick}
            >
                <span className="sr-only">Użyj opcji aby wyświetlić w epg tylko kanały dostępne w serwisie BM GO</span>
                <span
                    aria-hidden="true"
                    className={`${isOn ? "bg-[#008DD2]" : "bg-gray-300"} pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out`}
                />
                <span
                    aria-hidden="true"
                    className={`${isOn ? "translate-x-5" : "translate-x-0"} pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow-sm ring-0 transition-transform duration-200 ease-in-out`}
                />
            </button>
        </li>
    );
};

export default PopupItemToggle;